export default __webpack_public_path__ + "assets/images/4052a948c5cd9f4860b188bc35b1763c.svg";